import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import { Col, Form, Row } from 'react-bootstrap';


export default function SetDescribealbeScoreComments({onAccept, onClose, studentName, index, positiveComment, negativeComment, recommendation}) {
  const [selectedItems, setSelectedItems] = useState(null);


  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [positive, setPositive] = useState(positiveComment);
  const [negative, setNegative] = useState(negativeComment);
  const [recommend, setRecommend] = useState(recommendation);

  useEffect(() => {
  }, []);

  const saveItem = function () {
    onAccept(index, positive, negative, recommend);
  }
  const formDialogFooter = function () {
    return (
      <GeneralDialogFooter onOkClick={() => { saveItem() }} onCancelClick={() => { onClose() }} saving={false} />
    )
  }

  return (
    <>
      <Dialog visible={true} style={{ width: '90%', maxWidth:"800px" }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
        header="ثبت نظر توصیفی" modal className="p-fluid" footer={() => formDialogFooter()} onHide={() => onClose()}>
          <Row style={{margin:"10px 0px 0px 0px", padding:"0px 0px 0px 0px"}}>
            <Col md={12}>
              {studentName}
            </Col>
          </Row>
          <Row style={{margin:"10px 0px 0px 0px", padding:"0px 0px 0px 0px"}}>
            <Col md={12}>
              نقاط قوت:
              <br></br>
              <textarea style={{width:"100%", height:"120px"}} onChange={(e)=>{setPositive(e.target.value)}} value={positive} />
            </Col>
          </Row>
          <Row style={{margin:"10px 0px 0px 0px", padding:"0px 0px 0px 0px"}}>
            <Col md={12}>
              نقاط ضعف:
              <br></br>
              <textarea style={{width:"100%", height:"120px"}} onChange={(e)=>{setNegative(e.target.value)}} value={negative} />
            </Col>
          </Row>
          <Row style={{margin:"10px 0px 0px 0px", padding:"0px 0px 0px 0px"}}>
            <Col md={12}>
              پیشنهاد:
              <br></br>
              <textarea style={{width:"100%", height:"120px"}} onChange={(e)=>{setRecommend(e.target.value)}} value={recommend} />
            </Col>
          </Row>
      </Dialog>




      <ShowError visible={errorVisible} message={errorMessage} closeError={() => { setErorVisible(false) }} />
    </>
  );
}
